<template>
  <BaseLayout page-default-back-link="/nativeTab/lawyer" pageTitle="律师详情" :showFooter="true">
    <div class="lawyer-details">
      <div class="header border">
        <div class="f-between f-y-center">
          <img class="avatarImage m-r-20" :src="jz1Image" />

          <div class="right f-between f-y-center f-1 border">
            <div class="flex">
              <div class="f-column f-x-center">
                <div class="title m-b-20">秦向荣</div>
                <div class="font-sm darkgray-font">重庆坤博律师事务所</div>
              </div>
            </div>
            <div class="share-btn m-r-25" @click="shareCard">
              <img class="shareImage m-r-15" src="@/assets/share-blue.png" />
              <div class="font">分享律师</div>
            </div>
          </div>
        </div>
        <div class="flex m-t-20 m-b-20">
          <div class="f-1 font-sm darkgray-font border-r">电话：18312341234</div>
          <div class="f-1 font-sm darkgray-font p-l-30 f-start">邮箱：lvxiaogou@163.com</div>
        </div>
      </div>
      <ProtrudeTitle title="法律服务产品" />
      <Tabs :data="tabsData" :activeValue="activeValue" @change="tabsChange" />
      <DetailsListItem
        v-for="(item, index) in listData"
        :key="index"
        :id="item.id"
        :image="item.image"
        :title="item.title"
        :lawTypeDictEs="item.lawTypeDictEs"
        :time="item.time"
        :clientNumber="item.clientNumber"
        :price="item.price"
      />
    </div>
    <template v-slot:footer>
      <div class="footer-btn">
        <img class="phoneImage m-r-35" src="@/assets/phone.png" />
        <span>联系律师</span>
      </div>
    </template>
  </BaseLayout>
</template>

<script>
import { ref, reactive } from 'vue'
import { DetailsListItem } from '@/view/lawyer/components'
import { viewUrl } from '@/utils/url'
import jz1Image from '@/assets/jz/1.png'
import ws1Image from '@/assets/jz/ws_1.png'
import ws2Image from '@/assets/jz/ws_2.png'

export default {
  setup(props, { emit }) {
    const tabsData = [
      {
        label: '全部',
        value: 1,
      },
      {
        label: '民事',
        value: 2,
      },
      {
        label: '刑事',
        value: 3,
      },
      {
        label: '行政',
        value: 4,
      },
      {
        label: '非诉讼',
        value: 5,
      },
    ]
    const listData = ref([
      {
        id: 1,
        image: ws1Image,
        title: '民事诉讼一审法律服务产品 (原告)',
        lawTypeDictEs: '民事法律事务>劳务报酬金融>劳务报酬',
        time: '2020-02-18',
        clientNumber: 10,
        price: '￥ 99.00',
      },
      {
        id: 2,
        image: ws2Image,
        title: '民事诉讼一审法律服务产品 (被告)',
        lawTypeDictEs: '民事法律事务>劳务报酬金融>劳务报酬',
        time: '2020-02-18',
        clientNumber: 10,
        price: '￥ 99.00',
      },
    ])

    const shareCard = () => {
      window.open(
        `${viewUrl}/card/lawyer?showPageHeader=0&inviterSsoAccountRoleId=107&userName=Oushihao&mobile=18319064747&orgName=Ouasdjkkj`
      )
    }
    const activeValue = ref(tabsData[0].value)
    const tabsChange = (item) => {
      activeValue.value = item.value
    }
    return {
      tabsData,
      listData,
      shareCard,
      activeValue,
      tabsChange,
      jz1Image,
    }
  },
  components: { DetailsListItem },
}
</script>

<style lang="scss">
.lawyer-details {
  display: flex;
  flex-direction: column;

  .header {
    padding: 20px 0 0 35px;
    .avatarImage {
      width: 178px;
      height: 178px;
      border-radius: 50%;
    }
    .right {
      height: 178px;
    }
    .title {
      font-size: 36px;
    }
    .share-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 230px;
      height: 90px;
      box-sizing: border-box;
      background-color: #f4f6f9;
      border-radius: 12px;
      .shareImage {
        width: 38px;
        height: 38px;
      }
    }
  }

  .body {
  }
}
</style>